import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { BiddersForTable } from '../../types'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_WORKSPACE_BIDDERS } from './api/query'
import { BiddersForTableDTO, Data, Variables } from './api/types'
import { UseGetBidders, UseGetBiddersProps } from './types'

export const useGetBidders = ({
  filters,
  first,
  last,
  sort,
}: UseGetBiddersProps): UseGetBidders => {
  const { workspaceId } = useWorkspaceParam()
  const [bidders, setBidders] = useState<BiddersForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { nodes: bidders, totalCount: count } = data.workspaceBidders

      if (bidders) {
        setBidders(bidders.map((bidder: BiddersForTableDTO): BiddersForTable => fromDTO(bidder)))
        setCount(count)
      }
    },
    query: GET_WORKSPACE_BIDDERS,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { bidders, count, loading }
}
